import DayPicker from 'lib/DatePicker/DayPicker';
import { DATE_FORMAT } from 'modules/api/constants';
import { FilterDateRangeProps } from './FilterDateRange.types';

const FilterDateRange: React.FC<FilterDateRangeProps> = ({
  changeFilters,
  isDisabled,
  placeholderEndDate,
  placeholderStartDate,
  selectedStartDate: startDate,
  selectedEndDate: endDate,
}) => {
  return (
    <div className="flex w-full min-w-0 flex-col gap-y-2 sm:w-fit sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-4 sm:gap-y-2">
      <div className="w-full min-w-0 sm:w-[200px] sm:shrink-0">
        <DayPicker
          dataTestId="start-date-picker"
          onDayChange={(value: Date) => {
            changeFilters({
              startDate: value,
              endDate: endDate && value > endDate ? undefined : endDate,
            });
          }}
          placeholder={placeholderStartDate || 'Search by timeframe'}
          format={DATE_FORMAT}
          selectedDay={startDate}
          isDisabled={isDisabled}
          isClearable
        />
      </div>
      <span className="hidden sm:inline text-neutral-600 shrink-0">-</span>
      <div className="w-full min-w-0 sm:w-[200px] sm:shrink-0">
        <DayPicker
          dataTestId="end-date-picker"
          onDayChange={(value: Date) => {
            changeFilters({ startDate, endDate: value });
          }}
          placeholder={placeholderEndDate || 'Search by timeframe'}
          format={DATE_FORMAT}
          selectedDay={endDate}
          disabledDays={startDate ? [{ before: startDate }] : []}
          isDisabled={isDisabled}
          align="right"
          isClearable
        />
      </div>
    </div>
  );
};

export default FilterDateRange;
